export default __webpack_public_path__ + "static/media/logo.b2eb473d.png";